import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Arrow-style tooltip bubble portaled via CDK Overlay by AncTooltipDirective.
 * Figma Design System — Tooltip (Anchor: Top, Type: TextOnly).
 */
@Component({
    selector: 'lib-anc-tooltip-bubble',
    standalone: true,
    templateUrl: './anc-tooltip-bubble.component.html',
    styleUrls: ['./anc-tooltip-bubble.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncTooltipBubbleComponent {
    text = input('');
    /** When true, the bubble's text stays selectable so it can be copied. */
    selectable = input(false);
    /** Which side of the host the bubble renders on — flips the arrow to match. */
    placement = input<'top' | 'bottom'>('bottom');
}
